import { useState } from "react";
import { User } from "lucide-react";

export default function Avatar({ src, name, size = 40, testid }) {
  const [errored, setErrored] = useState(false);
  const initials = (name || "?")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join("");
  const style = { width: size, height: size, fontSize: Math.max(10, size * 0.36) };

  if (src && !errored) {
    return (
      <img
        src={src}
        alt={name || "profile"}
        onError={() => setErrored(true)}
        className="rounded-full object-cover bg-black border border-white/10"
        style={style}
        data-testid={testid}
      />
    );
  }

  return (
    <div
      className="rounded-full bg-[#1F1F1F] border border-white/10 flex items-center justify-center text-zinc-300 font-mono-data font-semibold"
      style={style}
      data-testid={testid}
    >
      {initials || <User className="w-1/2 h-1/2 opacity-60" />}
    </div>
  );
}
